import CollaborationStore from "@/store/collaboration.store";
import { useCallback, useMemo } from "react";
import { TranslationOption } from "@/constants/translate";
import ScrollableContent from "../ScrollableContent";
import { isIOSSafari } from '@/utils/platform';

const SrcContent = () => {
  const srcContent = CollaborationStore((state) => state.srcContent);
  const unstableText = CollaborationStore((state) => state.unstableText);
  const unstableTranslateText = CollaborationStore((state) => state.unstableTranslateText);
  const translationOption = CollaborationStore((state) => state.translationOption);

  // 缓存 iOS Safari 检测结果
  const isIOSSafariBrowser = useMemo(() => isIOSSafari(), []);

  // 渲染原文内容
  const renderContent = useCallback((isTrans: boolean) => {
    return (
      <ScrollableContent
        data={srcContent}
        unstableText={isTrans ? unstableTranslateText : unstableText}
        isTrans={isTrans}
        className={`flex-1 ${translationOption === TranslationOption.both ? isTrans ? "h-[calc(50%-24px)] pt-6" : "h-[calc(50%-24px)] pb-6" : "h-[calc(100%-48px)]"
          }`}
      />
    );
  }, [srcContent, unstableText, translationOption]);

  return (
    <div className="flex-1 h-full overflow-hidden flex flex-col">
      {/* 原文区域 */}
      {translationOption !== TranslationOption.translation && renderContent(false)}

      {/* 分割线 */}
      {translationOption === TranslationOption.both && (
        <div
          className="mx-2"
          style={{
            height: '1px',
            background: 'linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.1) 15%, rgba(0, 0, 0, 0.1) 85%, rgba(0, 0, 0, 0) 100%)'
          }}
        />
      )}

      {/* 译文区域 */}
      {translationOption !== TranslationOption.original && renderContent(true)}
      {/* 底部间距，iOS Safari 需要额外的安全区域间距避免被导航栏遮挡 */}
      <div
        className='h-6'
        style={isIOSSafariBrowser ? {
          paddingBottom: 'env(safe-area-inset-bottom)',
          marginBottom: 'max(env(safe-area-inset-bottom), 100px)'
        } : undefined}
      ></div>
    </div>
  );
};

export default SrcContent;
